import axios from 'axios';

import { getAccessToken } from "../security/AuthProvider";

const axiosInstance = axios.create();

const responseToError = (error) => {
    if (error.response && error.response.data) {
        return error.response.data;
    }

    if (error.message) {
        return error.message;
    }

    return 'Something went wrong';
}

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
	    if (error.message.includes('status code 403') || error.message.includes('status code 401') || error.message.includes('Network Error')) {
            window.location.href = '/';
        } else {
        }

	    return Promise.reject(responseToError(error));
    }
);

axiosInstance.interceptors.request.use(async function (config) {
    const token = await getAccessToken();
    if (typeof token.idToken != 'undefined') {
        config.headers.common.Authorization = 'Bearer ' + token.idToken;
    }

    return config;
});

export default axiosInstance;